// extracted by mini-css-extract-plugin
export default {"heading":"BuildingLoadingPlacesView_heading__3oYaO"};